<template>
  <div id="menu-administration" role="tabpanel" class="tab-pane show" aria-labelledby="administration-tab">
    <div class="submenu-nav-header">
      <div class="my-1 d-lg-none"></div>
      <h4 class="mb-0">Administration</h4>
      <small class="mb-1"><i>Administration related functionality</i></small>
    </div>
    <ul class="nav nav-pills" id="submenu-administration" role="tablist">
      <li v-if="security.isAboveACMStaff()" class="nav-item">
        <a id="sm-account-types-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('account-types')}" data-toggle="tab"
           href="#sm-account-types" role="tab" aria-controls="sm-account-types"
           aria-selected="true">
          <fa-icon icon="sitemap"/>&nbsp;&nbsp;Account Types</a>
      </li>
      <li v-if="security.canView('partners')" class="nav-item">
        <a id="sm-partners-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('partners')}" data-toggle="tab"
           href="#sm-partners" role="tab" aria-controls="sm-partners"
           aria-selected="true">
          <fa-icon icon="umbrella"/>&nbsp;&nbsp;Partners</a>
      </li>
      <li v-if="security.canView('agencies')" class="nav-item">
        <a id="sm-agencies-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('agencies')}" data-toggle="tab"
           href="#sm-agencies" role="tab" aria-controls="sm-agencies"
           aria-selected="true">
          <fa-icon icon="suitcase"/>&nbsp;&nbsp;Agencies</a>
      </li>
      <li v-if="security.isAboveClient() || (security.canView('clients') && security.belongsToMultipleClients())" class="nav-item">
        <a id="sm-clients-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('clients')}" data-toggle="tab"
           href="#sm-clients" role="tab" aria-controls="sm-clients"
           aria-selected="true">
          <fa-icon icon="handshake"/>&nbsp;&nbsp;Clients</a>
      </li>
      <li v-if="security.canView('users')" class="nav-item">
        <a id="sm-users-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('users')}" data-toggle="tab"
           href="#sm-users" role="tab" aria-controls="sm-users"
           aria-selected="true">
          <fa-icon icon="users"/>&nbsp;&nbsp;Users</a>
      </li>
      <li v-if="security.canView('api_bridges_webfleet') || security.canView('api_bridges_rabbitmq')" class="nav-item">
        <a id="sm-api-bridges-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('api-bridges')}" data-toggle="tab"
           href="#sm-api-bridges" role="tab" aria-controls="sm-api-bridges"
           aria-selected="true">
          <fa-icon icon="network-wired"/>&nbsp;&nbsp;API Bridges</a>
      </li>
    </ul>
    <div class="tab-content">
      <hr class="mt-2">
      <div v-if="security.isAboveACMStaff()"
           id="sm-account-types" role="tabpanel" class="tab-pane"
           :class="{active: isMenuTabActive('account-types')}">
        <div class="row">
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.accountTypeCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.accountTypeCreate.icon" :class="menu.accountTypeCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.accountTypeCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.accountTypeCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.accountTypeFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.accountTypeFind.icon" :class="menu.accountTypeFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.accountTypeFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.accountTypeFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-partners" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('partners')}">
        <div class="row">
          <div v-if="security.canCreate('partners')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.partnerCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.partnerCreate.icon" :class="menu.partnerCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.partnerCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.partnerCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.partnerFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.partnerFind.icon" :class="menu.partnerFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.partnerFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.partnerFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-agencies" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('agencies')}">
        <div class="row">
          <div v-if="security.canCreate('agencies')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.agencyCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.agencyCreate.icon" :class="menu.agencyCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.agencyCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.agencyCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.agencyFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.agencyFind.icon" :class="menu.agencyFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.agencyFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.agencyFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="exchange-alt" />&nbsp;Transfer Agency</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.agencyTransfer.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.agencyTransfer.icon" :class="menu.agencyTransfer.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.agencyTransfer.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.agencyTransfer.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-clients" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('clients')}">
        <div class="row">
          <div v-if="security.canCreate('clients')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.clientCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.clientCreate.icon" :class="menu.clientCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.clientCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.clientCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.clientFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.clientFind.icon" :class="menu.clientFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.clientFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.clientFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.clientContactFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.clientContactFind.icon" :class="menu.clientContactFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.clientContactFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.clientContactFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="security.isAboveClient()" class="row">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="exchange-alt" />&nbsp;Transfer Client(s)</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.isAbovePartner()" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.clientTransfer.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.clientTransfer.icon" :class="menu.clientTransfer.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.clientTransfer.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.clientTransfer.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.AssetTransfer.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.AssetTransfer.icon" :class="menu.AssetTransfer.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.AssetTransfer.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.AssetTransfer.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-users" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('users')}">
        <div class="row">
          <div v-if="security.canCreate('users')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.userCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.userCreate.icon" :class="menu.userCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.userCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.userCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.userFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.userFind.icon" :class="menu.userFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.userFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.userFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="security.isAbove(3)" class="row">
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.userHistory.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.userHistory.icon" :class="menu.userHistory.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.userHistory.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.userHistory.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div v-if="security.canView('api_bridges_webfleet') || security.canView('api_bridges_rabbitmq')" id="sm-api-bridges" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('api-bridges')}">
        <div class="row" v-if="security.canView('api_bridges_webfleet')">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="network-wired" />&nbsp;Webfleet API Bridges</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.canCreate('api_bridges_webfleet')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.apiBridgeWebfleetCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.apiBridgeWebfleetCreate.icon" :class="menu.apiBridgeWebfleetCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.apiBridgeWebfleetCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.apiBridgeWebfleetCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.apiBridgeWebfleetFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.apiBridgeWebfleetFind.icon" :class="menu.apiBridgeWebfleetFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.apiBridgeWebfleetFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.apiBridgeWebfleetFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row" v-if="security.canView('api_bridges_rabbitmq')">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="network-wired" />&nbsp;RabbitMQ API Bridges</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.canCreate('api_bridges_rabbitmq')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.apiBridgeRabbitMqCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.apiBridgeRabbitMqCreate.icon" :class="menu.apiBridgeRabbitMqCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.apiBridgeRabbitMqCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.apiBridgeRabbitMqCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.apiBridgeRabbitMqFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.apiBridgeRabbitMqFind.icon" :class="menu.apiBridgeRabbitMqFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.apiBridgeRabbitMqFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.apiBridgeRabbitMqFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuItems from '@/common/menu'
import security from '@/common/security'

import {
  NAV_GET_MENU_OPEN,
  NAV_SET_MENU_OPEN
} from '@/store/navigation/nav.types'

export default {
  data () {
    return {
      menu: menuItems,
      activeMenuTab: ''
    }
  },

  mounted () {
    // Check which of the tabs should be active based
    // on what the user can access:
    if (security.isAboveACMStaff()) {
      this.activeMenuTab = 'account-types'
    } else if (security.canView('partners')) {
      this.activeMenuTab = 'partners'
    } else if (security.canView('agencies')) {
      this.activeMenuTab = 'agencies'
    } else if (security.isAboveClient() || (security.canView('clients') && security.belongsToMultipleClients())) {
      this.activeMenuTab = 'clients'
    } else if (security.canView('users')) {
      this.activeMenuTab = 'users'
    } else if (security.canView('api_bridges_webfleet') || security.canView('api_bridges_rabbitmq')) {
      this.activeMenuTab = 'api-bridges'
    }
  },

  methods: {
    setMenuState () {
      this.$store.commit(NAV_SET_MENU_OPEN, !this.getMenuState())
    },

    getMenuState () {
      return this.$store.getters[NAV_GET_MENU_OPEN]
    },

    isMenuTabActive (tabName) {
      return tabName === this.activeMenuTab
    }
  },

  components: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/navigation/NavMenuAdministration.vue